/**
 * Date formatting shared by the week pickers and the admin console.
 *
 * "Week 3" is a label the NFL uses and nobody schedules their life around. The
 * question anyone actually has in front of a week picker is *which Sunday is
 * that*, and the answer is a date. So every place that offers a week now offers
 * the range alongside it.
 */

const MONTH = new Intl.DateTimeFormat(undefined, { month: 'short' })

function monthDay(at: number): { month: string; day: number } {
  const d = new Date(at)
  return { month: MONTH.format(d), day: d.getDate() }
}

/**
 * "Oct 2-8", or "Sep 28-Oct 4" when the window crosses a month boundary.
 *
 * The month is printed once when it can be, because "Oct 2-Oct 8" makes a
 * reader check whether the two months differ, and they never do.
 */
export function weekRange(startsAt: number, endsAt: number): string {
  const a = monthDay(startsAt)
  const b = monthDay(endsAt)
  return a.month === b.month
    ? `${a.month} ${a.day}-${b.day}`
    : `${a.month} ${a.day}-${b.month} ${b.day}`
}

/** "Week 3 · Oct 2-8" — the label a picker shows. */
export function weekLabelWithRange(label: string, startsAt: number, endsAt: number): string {
  return `${label} · ${weekRange(startsAt, endsAt)}`
}

/** "Sun Oct 5" from a `YYYY-MM-DD` gathering date, or null. */
export function gatheringShortLabel(dateStr: string | null): string | null {
  if (!dateStr) return null
  const [y, m, d] = dateStr.split('-').map((n) => parseInt(n, 10))
  if (!y || !m || !d) return null
  const at = new Date(y, m - 1, d, 12, 0, 0)
  return new Intl.DateTimeFormat(undefined, { weekday: 'short', month: 'short', day: 'numeric' }).format(at)
}
